/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ProcessMessageIndexType {
  procautoevent = "procautoevent",
  procrequest = "procrequest",
  procterminate = "procterminate",
}

export interface ProcessDraftInput {
  companySysId?: string | null;
  processId?: string | null;
  name?: string | null;
  description?: string | null;
  instructions?: (any | null)[] | null;
  outputs?: any | null;
}

export interface ProcessDraftParams {
  companySysId?: string | null;
  processId?: string | null;
  name?: string | null;
  instructions?: (any | null)[] | null;
}

export interface ProcessMessageInput {
  requestSysId: string;
  companySysId: string;
  processId: string;
  indexType: ProcessMessageIndexType;
  name?: string | null;
  description?: string | null;
  cis?: (string | null)[] | null;
  instructions: (any | null)[];
  user?: RequestUser | null;
  processInputs?: any | null;
}

export interface ProcessRequestParams {
  companySysId?: string | null;
  requestSysId?: string | null;
  processId?: string | null;
  name?: string | null;
  cis?: (string | null)[] | null;
  description?: string | null;
}

export interface ProcessTemplateInput {
  companySysId: string;
  processId: string;
  name?: string | null;
  description?: string | null;
  instructions: any[];
  outputs?: any | null;
  processInputs?: any | null;
}

export interface RequestUser {
  id?: string | null;
  name?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
